Namespace 'Customer.Users'

class Customer.Users.MergeableProfileView extends Backbone.View
  template: JST['backbone/templates/customer/users/mergeable_profile']
  className: 'mergeable-profile'
  events:
    'change .selector input:checkbox': 'toggleChecked'

  initialize: (extendedProfile, definitions) ->
    @extendedProfile = extendedProfile
    @definitions = definitions

  render: ->
    @$el.html(@template(
      name: @getSocialUser().name()
      username: @getSocialUser().username()
      avatar: @getSocialUser().avatar()
      attributes: @_customAttributes()
      socialNetwork: @socialNetworkName()
    ))
    @_applyStyle()
    @toggleChecked()
    @

  toggleChecked: =>
    checked = @isChecked()
    @$el.toggleClass('checked', checked)
    @$el.find('.attributes input:checkbox').prop('disabled', not checked)

  isChecked: =>
    @$el.find('.selector input:checkbox').is(':checked')

  getSocialUser: =>
    @extendedProfile.mainSocialUser()

  getValues: (code) =>
    values = []
    checked = @$el.find(".attribute[data-code='#{code}'] input:checkbox:checked")
    return values unless checked.length > 0 and @isChecked()
    socialUserID = @getSocialUser().get('id')
    for item in checked
      values.push
        value: @getValue(item)
        social_user: socialUserID
    values

  getValue: (item) =>
    parent = $(item).parent()
    return String(parent.data('value')) if @isAttributeTextType(parent.data('type'))
    parent.data('value')

  isAttributeTextType: (item_type) =>
    type = new Customer.ConversationAttribute.Definition[item_type]
    type._isText()

  getSocialUsersToMerge: =>
    return [] unless @isChecked()
    [@getSocialUser().get('id')]

  socialNetworkName: =>
    @getSocialUser().get('source')

  _customAttributes: =>
    attributes = []
    @definitions.forEach (definition) =>
      values = @extendedProfile.get('profile').get('values')[definition.get('code')]
      return if _.isUndefined(values)
      attributes.push
        name: definition.get('name')
        code: definition.get('code')
        type: definition.get('attribute_type_name')
        values: _.map(values, (value) -> value.value)
        isTag: definition.get('attribute_type_name') == 'FixedString'
        selected: @_shouldSelectAttribute(definition)
        singleValue: not definition.get('multiple')
    attributes

  _applyStyle: =>
    @$el.find('.header').css('color', window.color_for(@socialNetworkName()))

  _shouldSelectAttribute: (definition) ->
    definition.get('multiple')
